module.exports = __webpack_public_path__ + "img/takeDownW.eb6fac1a.png";